const $ = window.jQuery;

//import 'jquery-match-height';
import _ from 'lodash';

$(() => {
    function equalizeHeight() {
        const $equalize = $(`[data-equalize-height]`);
        let types = [];

        _.each($equalize, el => {
            const equalize_type = $(el).attr('data-equalize-height');
            if (types.indexOf(equalize_type) === -1) {
                types.push(equalize_type);
            }
        });

        _.each(types, type => {
            let heights = [];
            _.each($(`[data-equalize-height="${type}"]`), function(el) {
                heights.push($(el).outerHeight(true));
            });
            let tallest = 0;
            _.each(heights, height => {
                if (height > tallest) {
                    tallest = height;
                }
            });
            _.each($(`[data-equalize-height="${type}"]`), function(el) {
                $(el).css({ height: tallest });
            });
        });
    }

    setTimeout( () => {
        equalizeHeight();
    }, 500 );

    window.equalizeHeight = equalizeHeight;

    $( window ).on( 'resize orientationchange', () => {
        equalizeHeight();
    } );

});
